var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgConverartionNewD = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#converartion-new-d_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "converartion-new-d_svg__b",
  width: 80,
  height: 80,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M80 0H0v80h80V0Z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#converartion-new-d_svg__b)"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#242427",
  d: "M40 79.535c21.832 0 39.53-17.697 39.53-39.529C79.53 18.174 61.831.476 40 .476 18.17.477.47 18.175.47 40.007c0 21.831 17.699 39.53 39.53 39.53Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__c)",
  d: "M66.655 50.783a1.878 1.878 0 0 1-1.67 2.282l-.644.055-1.051 2.708.528 2.695a2.087 2.087 0 0 1-1.878 2.483m4.715-10.223L61.94 61.006Zm0 0-7.542-33.988a1.877 1.877 0 0 0-1.975-1.47c-6.47.49-17.834 1.381-24.648 1.992a3.52 3.52 0 0 0-3.2-2.067H17.079c-2.097 0-3.781 1.718-3.781 3.819v6.77c0 2.1 1.685 3.818 3.781 3.818h3.984c1.514 7.933 4.902 25.435 5.522 28.37.3 1.417.69 2.414 1.092 3.1.362.617.775 1.047 1.2 1.243.468.33 1.087.514 1.7.625.652.118 1.387.17 2.121.183 1.462.028 3.002-.091 4.008-.17h.01c.396-.03.692-.054.882-.061.18-.007.766-.05 1.64-.116.029.37.055.716.077 1.023a.956.956 0 0 0 1.573.66l1.286-1.093 1.255.972c.613.475 1.54.059 1.535-.755a26.64 26.64 0 0 0-.04-1.254m21.732-11.601L44.923 62.384ZM61.94 61.006c-4.89.4-11.803.962-17.017 1.378Zm0 0-17.017 1.378ZM41.824 63.15Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#converartion-new-d_svg__d)",
  strokeWidth: 1.5,
  d: "M66.655 50.783a1.878 1.878 0 0 1-1.67 2.282m1.67-2.282L61.94 61.006m4.715-10.223-7.542-33.988a1.877 1.877 0 0 0-1.975-1.47c-6.47.49-17.834 1.381-24.648 1.992a3.52 3.52 0 0 0-3.2-2.067H17.079c-2.097 0-3.781 1.718-3.781 3.819v6.77c0 2.1 1.685 3.818 3.781 3.818h3.984c1.514 7.933 4.902 25.435 5.522 28.37.3 1.417.69 2.414 1.092 3.1.362.617.775 1.047 1.2 1.243.468.33 1.087.514 1.7.625.652.118 1.387.17 2.121.183 1.462.028 3.002-.091 4.008-.17h.01c.396-.03.692-.054.882-.061.18-.007.766-.05 1.64-.116.029.37.055.716.077 1.023a.956.956 0 0 0 1.573.66m25.768-13.731L44.923 62.384m20.061-9.32-.064-.746m.064.747-.643.055-1.051 2.708.528 2.695a2.087 2.087 0 0 1-1.878 2.483m0 0c-4.89.4-11.803.962-17.017 1.378m17.017-1.378-17.017 1.378m-4.036 2.13Zm0 0 1.286-1.093 1.255.972c.613.475 1.54.059 1.535-.755a26.64 26.64 0 0 0-.04-1.254m-3.1.766Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "converartion-new-d_svg__e",
  width: 46,
  height: 48,
  x: 20,
  y: 16,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M65.994 16H20.981v48h45.013V16Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#converartion-new-d_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3AA6EF",
  d: "M37.52 62.197c-1.288.052-6.696.721-8.292-.463-1.597-.927-3.297-11.374-4.12-16.79l34.763-2.42 3.163 16.143a1.337 1.337 0 0 1-1.202 1.592c-8.566.698-23.342 1.9-24.313 1.938Z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#converartion-new-d_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__g)",
  d: "M34.584 60.807c-3.996.33-4.995-1.476-4.995-2.42l-.618-3.863 35.073-2.833-2.678 6.902c-7.262.6-22.785 1.885-26.782 2.214Z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#converartion-new-d_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A97E6",
  d: "m65.875 50.945-7.542-33.987a1.127 1.127 0 0 0-1.186-.884c-7.899.596-23.088 1.794-28.383 2.347-6.9.72-8.085 5.253-7.725 7.313.36 2.06 5.46 28.48 6.232 32.137.618 2.926 1.596 3.794 2.008 3.863-2.008-2.472 1.648-6.438 5.666-6.901 3.846-.444 20.002-1.66 29.928-2.515a1.128 1.128 0 0 0 1.002-1.373Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__i)",
  fillOpacity: 0.5,
  d: "m65.875 50.945-7.542-33.987a1.127 1.127 0 0 0-1.186-.884c-7.899.596-23.088 1.794-28.383 2.347-6.9.72-8.085 5.253-7.725 7.313.36 2.06 5.46 28.48 6.232 32.137.618 2.926 1.596 3.794 2.008 3.863-2.008-2.472 1.648-6.438 5.666-6.901 3.846-.444 20.002-1.66 29.928-2.515a1.128 1.128 0 0 0 1.002-1.373Z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#converartion-new-d_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__k)",
  d: "m50.797 24.348-14.43 1.304a1.339 1.339 0 0 0-1.195 1.586l1.348 7.04a1.34 1.34 0 0 0 1.435 1.081l14.505-1.303a1.339 1.339 0 0 0 1.193-1.599l-1.423-7.04a1.339 1.339 0 0 0-1.433-1.069Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#CBD9E2",
  fillRule: "evenodd",
  d: "M51.166 28.227a.36.36 0 0 1-.328.39L37.705 29.75a.36.36 0 1 1-.062-.718l13.133-1.133a.36.36 0 0 1 .39.328ZM49.622 30.645a.36.36 0 0 1-.327.392l-8.498.773a.36.36 0 0 1-.065-.719l8.498-.772a.36.36 0 0 1 .392.326Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__l)",
  fillRule: "evenodd",
  d: "M61.518 56.654a.36.36 0 0 1-.326.392L33.02 59.62a.36.36 0 1 1-.065-.718l28.171-2.575a.36.36 0 0 1 .392.326Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__m)",
  fillRule: "evenodd",
  d: "M61.466 54.594a.36.36 0 0 1-.326.392l-28.172 2.575a.36.36 0 0 1-.065-.718l28.172-2.575a.36.36 0 0 1 .391.326Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#converartion-new-d_svg__n)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F34C60",
  d: "m43.403 57.218-3.794.324a.213.213 0 0 0-.19.251c.22 1.231.47 4.256.596 6.007.012.169.21.251.34.142l1.621-1.379a.206.206 0 0 1 .26-.005L43.84 63.8c.134.103.327.01.326-.159-.012-1.95-.344-4.82-.542-6.248a.204.204 0 0 0-.22-.175Z"
})))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__o)",
  d: "M14 19.069C14 17.374 15.357 16 17.031 16h12.213c1.53 0 2.772 1.256 2.772 2.806v7.085c0 1.666-1.334 3.016-2.98 3.016-.413 0-.47 1.93-.866 1.93-.412 0-1.162-1.93-1.56-1.93h-9.578c-1.674 0-3.032-1.374-3.032-3.068v-6.77Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__p)",
  d: "M27.247 23.948a1.59 1.59 0 1 0 0-3.18 1.59 1.59 0 0 0 0 3.18Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__q)",
  d: "M23.009 23.948a1.59 1.59 0 1 0 0-3.18 1.59 1.59 0 0 0 0 3.18Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#converartion-new-d_svg__r)",
  d: "M18.768 23.948a1.59 1.59 0 1 0 0-3.18 1.59 1.59 0 0 0 0 3.18Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__c",
  x1: 22.779,
  x2: 48.409,
  y1: 20.882,
  y2: 60.747,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__d",
  x1: 22.779,
  x2: 48.409,
  y1: 20.882,
  y2: 60.747,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__g",
  x1: 46.507,
  x2: 59.051,
  y1: 51.691,
  y2: 58.328,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__i",
  x1: 55.082,
  x2: 27.116,
  y1: 39.743,
  y2: 44.996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.025,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#489BDB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__k",
  x1: 44.422,
  x2: 44.422,
  y1: 24.24,
  y2: 35.468,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__l",
  x1: 32.936,
  x2: 61.159,
  y1: 59.262,
  y2: 56.687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F0F0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#B7B7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E3E3E3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__m",
  x1: 32.884,
  x2: 61.108,
  y1: 57.202,
  y2: 54.627,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F0F0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#B7B7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E3E3E3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__o",
  x1: 17.713,
  x2: 23.122,
  y1: 16,
  y2: 29.732,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FE3AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#4E72DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__p",
  x1: 28.125,
  x2: 25.869,
  y1: 21.48,
  y2: 23.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__q",
  x1: 23.887,
  x2: 21.631,
  y1: 21.48,
  y2: 23.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "converartion-new-d_svg__r",
  x1: 19.647,
  x2: 17.39,
  y1: 21.48,
  y2: 23.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("filter", {
  id: "converartion-new-d_svg__f",
  width: 49.073,
  height: 23.155,
  x: 28.971,
  y: 51.691,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 14,
  dy: 14
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_17392_44256"
})), /*#__PURE__*/React.createElement("filter", {
  id: "converartion-new-d_svg__h",
  width: 48.921,
  height: 50.664,
  x: 16.981,
  y: 11.07,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: -5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.14902 0 0 0 0 0.486275 0 0 0 0 0.780392 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_17392_44256"
})), /*#__PURE__*/React.createElement("filter", {
  id: "converartion-new-d_svg__j",
  width: 19.532,
  height: 12.021,
  x: 34.148,
  y: 24.343,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_17392_44256"
})), /*#__PURE__*/React.createElement("filter", {
  id: "converartion-new-d_svg__n",
  width: 5.25,
  height: 7.273,
  x: 39.416,
  y: 56.718,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: -0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_17392_44256"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_17392_44256",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_17392_44256"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "converartion-new-d_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})))));
export { SvgConverartionNewD as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzg0ZmUzMDIxNWZlMDM3OGM4NDNjODhiZGI2MjcwZjkuc3ZnIjs=";